import $ from 'jquery';

$(window).on('load', function() {
    $('.search-header-block-input').addClass('hide');
});


$('.search-header-block .search-form').on('click', function() {
    $('.search-header-block-input').toggleClass('hide');
});


// Calc heignt header.header and add value to .search-header-block-input for correct position attribute top
$(window).on('load resize', function() {
    var headerHeight = $('.header').outerHeight();
    $('.search-header-block-input').css('top', headerHeight);
});

// Add placeholder in input#edit-keys with "Search" value translated
$(window).on('load', function() {
    var searchPlaceholder = Drupal.t('Search');
    $('.search-header-block-input #edit-keys').attr('placeholder', searchPlaceholder);
});
